const DEFAULT_API_BASE_URL = 'https://api.dialtpr.com/api';

const normalizeBaseUrl = () => {
  const raw = process.env.REACT_APP_API_BASE_URL;
  const trimmed = typeof raw === 'string' && raw.trim().length > 0 ? raw.trim() : DEFAULT_API_BASE_URL;
  return trimmed.replace(/\/$/, '');
};

export const buildPublicApiUrl = (path) => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const base = normalizeBaseUrl();
  const baseHasPublic = /\/public$/i.test(base);
  const prefix = baseHasPublic ? base : `${base}/public`;
  return `${prefix}${normalizedPath}`;
};

export const getApiBaseUrl = () => normalizeBaseUrl();
